module.exports = __webpack_public_path__ + "img/coingecko.fc933657.svg";